import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("How do you stack up against other accounts?")
const _hoisted_2 = { class: "flex items-center flex-grow p-3 flex-row flex-wrap justify-center" }
const _hoisted_3 = { class: "flex-grow" }
const _hoisted_4 = { class: "text-2xl font-bold text-center" }
const _hoisted_5 = { class: "relative p-2" }
const _hoisted_6 = { class: "absolute top-0 left-0 w-full h-full flex items-center justify-center" }
const _hoisted_7 = { class: "font-bold text-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DonutChart = _resolveComponent("DonutChart")!
  const _component_DashboardCard = _resolveComponent("DashboardCard")!

  return (_openBlock(), _createBlock(_component_DashboardCard, {
    title: "Activity Rank",
    embed: "embed:rank"
  }, {
    help: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, " #" + _toDisplayString(_ctx.$filters.number.standard(_ctx.ranking)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_DonutChart, {
            fraction: (_ctx.percentile - 0.69) / 0.31,
            trackThickness: 10,
            thickness: 10,
            lineCap: "round",
            color: "rgb(124, 58, 237)",
            trackColor: "rgba(126, 132, 140, 0.2)",
            class: "w-24 h-24"
          }, null, 8, ["fraction"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$filters.number.percent(_ctx.percentile)), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}